import { API } from '@/api';

const state = {
};

const getters = {
};

const actions = {
  async generateNom151({commit, state}, {clienteId, docId}) {
    const response = await API.post(`/nom151/${clienteId}/${docId}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async listNom151({commit, state}, {clienteId, options}) {
    let sortBy = '';
    let queryString = {};
    if (options !== undefined) {
      sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
      queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    }
    const response = await API.get(`/nom151/list/${clienteId}`, {params: queryString});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async listNom151ByDoc({commit, state}, {clienteId, docId, options}) {
    let sortBy = '';
    let queryString = {};
    if (options !== undefined) {
      sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
      queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    }
    const response = await API.get(`/nom151/list/${clienteId}/${docId}`, {params: queryString});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async downloadNom151({commit, state}, {clienteId, docId, nomId}) {
    const response = await API.get(`/nom151/${clienteId}/${docId}/${nomId}`, {responseType: 'blob'});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response;
  },
};

const mutations = {
};

export default {
  actions,
  mutations,
  getters,
  state,
};
